export default {
  title: 'Calculateur de revenus des frais de service',
  description:
    'Estimez ce que rapportent les frais de service chaque mois. Les chiffres se mettent à jour au fur et à mesure.',
  authoritative:
    'Le pourcentage et les frais maximum ci-dessous sont les paramètres qui seront appliqués. La valeur moyenne des commandes et le GMV mensuel ne sont que des estimations.',
  off_notice:
    'Les frais de service sont désactivés dans ce restaurant, ils ne rapportent donc encore rien. Enregistrez des frais supérieurs à zéro pour les activer.',
  fields: {
    recommended: 'Recommandé : {{value}}',
    aov: {
      label: 'Valeur moyenne des commandes',
      help: 'Panier moyen sur votre système de commande en ligne.',
      placeholder: 'ex. 32,50',
    },
    percentage: {
      label: 'Pourcentage des frais de service',
      help: 'Entre {{min}} % et {{max}} %.',
    },
    max_amount: {
      label: 'Frais maximum par commande',
      help: '{{max}} est le maximum de la plateforme.',
      below_min: "Le montant maximum des frais doit être d'au moins {{min}}.",
    },
    monthly_gmv: {
      label: 'GMV mensuel',
      help: 'Valeur totale des commandes traitées par mois.',
      placeholder: 'ex. 85000',
    },
  },
  outputs: {
    partner_revenue: 'Votre revenu mensuel estimé',
    approximate: 'Chiffre approximatif basé sur les valeurs ci-dessus — le revenu réel peut varier.',
    estimate_inputs: 'Basé sur votre valeur de commande et GMV estimés — le revenu réel peut varier.',
    share: "Il s'agit de votre part de {{share}} % du total des frais de service collectés.",
    total_collected: 'Total des frais de service collectés auprès des clients à la commande',
    total_collected_note: '— payé par les clients, pas un revenu supplémentaire par rapport au chiffre ci-dessus.',
    effective_rate: 'Taux de frais effectif sur toutes les commandes',
  },
};
